/**
 * Retro Cult header interactions: scroll shrink + search quick tags
 */
(function () {
  'use strict';

  function initScrollShrink() {
    const header = document.querySelector('#header-component.rc-header');
    if (!header) return;

    const threshold = 24;
    let ticking = false;

    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > threshold);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initSearchQuickTags() {
    document.querySelectorAll('[data-rc-search-term]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const term = btn.getAttribute('data-rc-search-term');
        const input = document.querySelector('#search-modal .search-input, #search-modal input[type="search"]');
        if (!input || !term) return;
        input.value = term;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.focus();
      });
    });
  }

  function init() {
    initScrollShrink();
    initSearchQuickTags();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
